import { Badge, Space } from "antd";
import React from "react";

const legends = [
  { id: "guaranteed", label: "Guaranteed", color: "#999999" },
  { id: "almost-guaranteed", label: "Selling Fast", color: "#999999" }
]

const Legends = () => {
  return (
    <div className="legends">
      <Space size={17}>
        {
          legends.map(legend => <Badge key={legend.id} className={legend.id} color={legend.color} text={legend.label} />)
        }
      </Space>
    </div>
  );
};

export default Legends;